import { render, staticRenderFns } from "./counterpartiesClosed.vue?vue&type=template&id=336a4fa6"
import script from "./counterpartiesClosed.vue?vue&type=script&lang=js"
export * from "./counterpartiesClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports